import _ from "lodash";
import { useState } from "react";
import { ethers } from "ethers";
import ERC20ABI from "../abi/ERC20ABI.json";
import { tokenContractAddress } from "../stateManagement/tokenAddressAtom";
import { useAtom } from "jotai";

export const useRemoveAssetUpdater = () => {
    const [message, setMessage] = useState("");
    const [waitRemoveAssetUpdater, setWaiRemoveAssetUpdater] = useState(false);
    const tokenAddress = localStorage.getItem("tokenContractAddress");

    const callRemoveAssetUpdater = async (
        signer: ethers.ContractRunner | null | undefined,
        address: string
    ) => {
        try {
            setWaiRemoveAssetUpdater(true);

            const callAbi = new ethers.Contract(
                tokenAddress || '',
                ERC20ABI.abi,
                signer
            );

            const tx = await callAbi.removeAssetUpdater(
                address
            );
            
            setWaiRemoveAssetUpdater(false);
            return { err: "", tx: tx };
        } catch (err: any) {
            const errs = _.get(err, "error.message");
            const msgs = _.get("", errs);
            if (err.code === "ACTION_REJECTED") {
                setWaiRemoveAssetUpdater(false);
                setMessage("User rejected transaction");
                return { err: "User rejected transaction", tx: "" };
            } else {
                if (msgs === undefined) {
                    setWaiRemoveAssetUpdater(false);
                    setMessage(err.message.split("(")[0] || "");
                    return { err: err.message.split("(")[0] || "", tx: "" };
                } else {
                    setWaiRemoveAssetUpdater(false);
                    setMessage(msgs.msg);
                    return { err: msgs.msg, tx: "" };
                }
            }
        }
    };

    return {
        onRemoveAssetUpdater: callRemoveAssetUpdater,
        waitRemoveAssetUpdater: waitRemoveAssetUpdater,
        messageError: message,
    };
};
